import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#009EE3",
      primaryHover: "#0688c0",
    },
    logoImage: logo,
    backend: "https://showcase.epaper-publishing-one.de/",
    header: {
      customer: "",
      title: "Showcase Kiosk",
    },    
    accToolbar: true,
    tracking: {
      type: 'GA4',
      id: '309884242',
      cookieConsent: {
        type: 'Free'
      }
    },
    info: [
          {
          text: 'Impressum',
          link: 'https://www.publishing.one/impressum/'
        },
          {
          text: 'Datenschutz',
          link: 'https://www.publishing.one/datenschutz/'
        },
    ],
    
  };